import { useParams } from 'react-router-dom';
import HelpPageSections, { HelpEntries } from '../components/HelpPage/HelpPageSections';
import Page from '../components/Page';

const expenditureHelpEntries: HelpEntries = {
  1: [
    {
      title: 'Essential Expenditure',
      content: 'This field should be populated with the applicants total monthly committed expenditures. This will then be compared with the expected ONS value for the household make-up and region and used for Affordability purposes. Depending on both system and underwriting checks there may be a need for this expenditure to be evidenced through bank statements, if this is the case you will be prompted.',
    },
    {
      title: 'Transport Expenditure',
      content: 'This field should be populated with the average monthly spend towards all transport for the household, both social and commuting/business. This should include the cost for travel, insurances, taxes, vehicle services/mots, parts etc.',
    },
    {
      title: 'Council Tax',
      content: 'This field should be populated with the average monthly spend on council tax for the household. This will then be compared with the expected value for the property. Depending on both system and underwriting checks there may be a need for this expenditure to be evidenced, if this is the case you will be prompted.',
    },
    {
      title: 'Insurances',
      content: 'This field should be populated with the average monthly spend towards all insurances except for transport related insurances.',
    },
  ],
};

export default function MonthlyExpenditureHelp() {
  const { version } = useParams();

  return (
    <Page>
      <HelpPageSections
        version={Number(version)}
        entries={expenditureHelpEntries}
      />
    </Page>
  );
}
